// E7 (47024, GES-388): quantity text at an item's own decimals (items.qty_decimals 0|1|2, null = no rule). The sibling of sanitizeMoney for quantities:
// digits + ONE '.', ',' normalised, no more decimals than the item takes (0 = whole units: no '.'). null / undefined decimals = text untouched (no rule).
// The engine still refuses (ITEM_QTY_PRECISION) what slips through; this only stops the typing.
export function sanitizeQty(text, decimals) {
  if (decimals == null || !Number.isInteger(Number(decimals))) return text;
  const s = String(text ?? '').replace(/,/g, '.').replace(/[^0-9.]/g, '');
  const i = s.indexOf('.');
  if (i < 0) return s;
  return Number(decimals) === 0 ? s.slice(0, i) : s.slice(0, i) + '.' + s.slice(i + 1).replace(/\./g, '').slice(0, Number(decimals));
}
// display: an item with a rule shows at most that many decimals, otherwise the app default (3)
export const qtyMaxDecimals = (decimals, dflt = 3) => (decimals == null ? dflt : Number(decimals));
